import React, {ReactNode, useEffect, useRef, useState} from 'react';
import {DetailGrid, Utility, wdiCore} from '@/components/GridWidget';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {FieldProps, WdiCardTitle, WdiModalAppProps, WdiModalAppResult, WdiModalProps,} from '@/components/WdiControls';
import {Button, Dropdown, Form, Menu, message, Space, Tooltip} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats,} from '@/components/WdiBus/TableColumnRanderFormats';
import DataStore from '@/components/GridWidget/DataStore';
import {formatter, responseIsSuccess, ResponseStatus} from '@/utils/request';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {last} from 'lodash';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {toExcel, ToExcelProps} from '@/components/WdiControls/WdiExcel';
import {EC} from '@/services/mdm/ec';
import FormSaDetailPrevApp from './DetailPrev';
import {getAllHasValueColumns, getProductSheet} from '../../components/data';
import FormSaDetailCompareModalApp from '../../components/FormSaDetailCompare';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ProFormInstance} from '@ant-design/pro-form';
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {FormSa, FormSaDetail} from '@/services/sales/sa';
import download from '@/utils/download';
import {FieldConfigUtility, getEcDefFields} from '@/components/WdiBus/EcFieldConfig';
import {SoldTo} from '@/services/mdm/soldto';
import DetailSellinQuantityApp from './DetailEditSellinQuantity';
import DetailSellinRevenueApp from './DetailEditSellinRevenue';
import DetailPosRevenueApp from './DetailEditPosRevenue';
import DetailPosQtySellinPriceApp from './DetailEditPosQtySellinPrice';
import DetailPosQtySupplyPriceApp from './DetailEditPosQtySupplyPrice';
import DetailFixedApp from '@/pages/sales/sa/GeneralActivityApply/components/DetailEditFixed';
import {
  ModalTypeEnums,
  showFixedModal,
  showPosQtySellinPriceModal,
  showPosQtySupplyPriceModal,
  showPosRevModal,
  showSellinQtyModal,
  showSellinRevModal,
} from '@/pages/sales/sa/GeneralActivityApply/components/DetailBase';
import {Shop} from '@/services/mdm/shop';
import {RevenueType} from '@/services/mdm/revenuetype';
import {BudgetProject} from '@/services/sales/bp/budgetProject';
import {Company} from "@/services/mdm/company";

export type DetailForApplyProps = {
  data?: {
    form?: API.Form;
    formSa?: API.FormSa;
    ecFieldConfigs?: API.EcFieldConfig[];
  };
  dataSource: any[];
  onChange?: (dataSource: any) => void;
};

const ExportTemplateModalApp: React.FC<WdiModalAppProps> = (props: WdiModalAppProps) => {
  const formRef = useRef<ProFormInstance>();

  const [revenueTypeOpts, setRevenueTypeOpts] = useState<any[]>();
  const [budgetProject, setBudgetProject] = useState<API.BudgetProject>();

  const {formSa} = props.data;

  useEffect(() => {
    if (formSa.budgetProjectId) {
      BudgetProject.get(formSa.budgetProjectId).then((response) => {
        setBudgetProject(response.data);
      });
    }
  }, [formSa.budgetProjectId]);

  const handleEcChange = async (ecId: any) => {
    if (ecId) {
      const revenueTypeRes = await RevenueType.search({
        ecId: ecId,
        applyType: Enum.RevApplyType.SA_GENERAL,
      });
      if (responseIsSuccess(revenueTypeRes)) {
        setRevenueTypeOpts(revenueTypeRes.data.map((item) => ({
            value: item.revenueTypeId,
            label: item.revenueTypeName
          })),
        );
      }
    }
  };

  return (
    <WdiModalForm
      {...HorzLayoutOpts}
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      submitter={{searchConfig: {submitText: '下载',},}}
      onFinish={async (values) => {
        const {ecId, revenueType, ...entity} = values;
        entity.ecId = WdiSelectFormat.getvalue(ecId);
        entity.revenueType = WdiSelectFormat.getvalue(revenueType);
        entity.pageTypeId = formSa.pageTypeId;
        entity.budgetProjectId = formSa.budgetProjectId;
        entity.tempName = 'ActivityGeneralApply.xlsx';
        await download(FormSa.Buttons.Path.downloadTempByEc, formatter({method: 'POST', body: {...entity}}));
        props.onClose?.()
      }}
    >
      <Form.Item name="ecId" label="费用项" rules={[{required: true, message: '费用项不能为空!'}]}>
        <WdiTreeSelect {...{
          placeholder: "请选择费用项",
          dataLoading: async (params) => {
            const response = await EC.searchEc3(Object.assign({
              toParentLevel: Enum.ECLevel.EC2,
              budgetProjectId: formSa.budgetProjectId,
              ecIds: budgetProject?.limitedEcIds,
              pageTypeIds: String(formSa.pageTypeId),
              isActive: true,
            }, params));
            const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
              textField: 'ecName',
              valueField: 'ecId',
              id: 'ecId',
              pId: 'parentId',
              level: 'ecLevel',
              disabledLevel: [Enum.ECLevel.EC2],
            }, response.data, (node: any, item: any) => {
              node.title = (
                <Tooltip placement="topLeft" title={item.remark}><span>{node.title}</span></Tooltip>
              );
              return node;
            });
            return {treeData, dict};
          },
          onChange: async (value) => {
            await handleEcChange(WdiSelectFormat.getvalue(value));
          },
          reloadKey: budgetProject?.limitedEcIds,
        }} />
      </Form.Item>
      <Form.Item name="revenueType" label="核算类型">
        <WdiSelect
          {...{
            placeholder: '请选择核算类型',
            showSearch: true,
            options: revenueTypeOpts,
          }}
        />
      </Form.Item>
    </WdiModalForm>
  )
}

/**
 默认列：四级使用部门，客户，门店，产品别，费用项，核算类型，支付方式，申请金额
 扩展列：一级~三级使用部门，费用大类，费用小类，是否同步到SFA，预计费比，备注
 */
const initRowFieldConfigs = (record: any, ecFieldConfigs: API.EcFieldConfig[] | undefined) => {
  const columns = ["boId", "soldToCode", "shopId", "productBuyIds", "ecId", "revenueType", "paymentMethodId", "amount",
    "companyCode", "boId1", "boId2", "boId3", "ecId1", "ecId2", "toSfa", "roiForecast", "remark"];
  columns.push(...getAllHasValueColumns(record));

  if (ecFieldConfigs && ecFieldConfigs.length > 0) {
    if (record.extendFieldsSa || record.revExtendFieldsSa) {
      columns.push(...getEcDefFields(ecFieldConfigs, FieldConfigUtility.merge(record.extendFieldsSa, record.revExtendFieldsSa)));
    }
  }
  return columns;
};

export const FormSaDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  // Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});
  const [exportModalProps, setExportModalProps] = useState<WdiModalProps>({visible: false});

  const {data, dataSource, onChange} = props;

  const onModalClose = () => {
    setModalProps({visible: false, title: "", type: ModalTypeEnums.NONE, id: null});
  };

  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      const newDataSource = [...dataSource];
      const result = uploadResult?.data?.data;

      if (result && result.length > 0) {
        if (uploadResult?.data?.exProperty) {
          //是否清空
          onChange?.(DataStore.init(result));
        } else {
          onChange?.(DataStore.addMulti(newDataSource, result));
        }
      }
    }
    setModalProps({visible: false, title: "", type: ModalTypeEnums.NONE, id: null});
  };

  const onPrevSave = (result?: WdiModalAppResult) => {
    const modalSetting = {
      visible: true,
      type: result?.data.formSaDetail.revenueType,
      data: {...result?.data, form: data?.form,},
    };
    if (result?.data.rowIndex === -1) {
      setModalProps({title: "新建费用明细", ...modalSetting});
    } else {
      setModalProps({title: "编辑费用明细", ...modalSetting});
    }
  };

  const onEditSave = (result?: WdiModalAppResult) => {
    if (result && result.code === ResponseStatus.SUCCESS) {
      const row = result?.data;
      if (result?.data.rowIndex > -1) {
        const record = modalProps.data.row;
        const newItem = {...row};
        newItem.uid = record.uid;
        onChange?.(DataStore.edit(dataSource, newItem));
      } else {
        const newItem = {...row};
        onChange?.(DataStore.add(dataSource, newItem));
      }
    }
    setModalProps({visible: false, title: "", type: ModalTypeEnums.NONE, id: null});
  };

  useEffect(() => {
    GridApi.searchConfig({id: 'FormSADetailForGeneral', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);
      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.ecId.width = 200;
      settings.formSchema.allFields.soldToCode.width = 180;
      settings.formSchema.allFields.revenueType.width = 120;
      settings.formSchema.allFields.paymentMethodId.width = 120;

      settings.formSchema.allFields.amount.width = 120;
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);

      Utility.setActionCallback(settings.formSchema.actions, 'Update',
        async (grid: any, action: any, record: any) => {
          const context = grid.getContext();
          setModalProps({
            visible: true,
            title: '选择费用类型',
            type: ModalTypeEnums.PREV,
            id: record.formSaDetailId,
            data: {
              row: record,
              rows: context.dataSource,
              rowIndex: DataStore.getRowIndex(context.dataSource, record.uid),
              formSa: context.params.formSa,
              form: context.params.form,
            }
          });
        },
      );

      Utility.setActionCallback(settings.formSchema.actions, 'Copy',
        async (grid: any, action: any, record: any) => {
          const context = grid.getContext();
          setModalProps({
            visible: true,
            title: '选择费用类型',
            type: ModalTypeEnums.PREV,
            id: record.formSaDetailId,
            data: {
              row: Object.assign({}, record, {formSaDetailIdOriginal: null}),
              rows: context.dataSource,
              rowIndex: -1,
              formSa: context.params.formSa,
            }
          });
        },
      );

      Utility.setActionCallback(settings.formSchema.actions, 'SystemDelete',
        async (grid: any, action: any, record: any) => {
          if (window.confirm("确定要删除吗？")) {
            const context = grid.getContext();
            onChange?.(DataStore.del(context.dataSource, record.uid));
            message.success("删除成功");
          }
        },
      );

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  useEffect(() => {
    const soldToSheet = {
      dataLoading: async (params: any) => {
        return await SoldTo.queryForSheet({
          isActive: true,
          withPermissions: true
        });
      },
      data: null,
      names: [
        {name: "soldToCode", displayName: "客户编号"},
        {name: "soldToName", displayName: "客户名称"},
        {name: "custSysCode", displayName: "客户组编号"},
        {name: "custSysName", displayName: "客户组名称"},
        {name: "boName4", displayName: "四级使用部门"},
        {name: "boName3", displayName: "三级使用部门"},
        {name: "boName2", displayName: "二级使用部门"},
        {name: "boName1", displayName: "一级使用部门"},
        {name: "custTypeCode3", displayName: "三级客户分类编号"},
        {name: "custTypeName2", displayName: "三级客户分类名称"},
        {name: "custTypeCode2", displayName: "二级客户分类编号"},
        {name: "custTypeName2", displayName: "二级客户分类名称"},
        {name: "custTypeCode1", displayName: "一级客户分类编号"},
        {name: "custTypeName1", displayName: "一级客户分类名称"},
        {name: "companyName", displayName: "公司名称"},
      ],
      sheetName: "客户列表",
    };
    const shopSheet = {
      dataLoading: async (params: any) => {
        return await Shop.exportShop({
          isActive: true,
          withPermissions: true
        });
      },
      data: null,
      names: [
        {name: "shopCode", displayName: "门店编号"},
        {name: "shopName", displayName: "门店名称"},
        {name: "soldToCode", displayName: "客户编号"},
        {name: "soldToName", displayName: "客户名称"},
        {name: "shopSysName", displayName: "门店系统名称"},
        {name: "shopTypeName1", displayName: "门店一级分类"},
        {name: "shopTypeName2", displayName: "门店二级分类"},
        {name: "shopLevelName", displayName: "门店等级"},
        {name: "address", displayName: "地址"},
        {name: "city", displayName: "城市"},
        {name: "province", displayName: "省份"},
        {name: "contactName", displayName: "联系人"},
        {name: "contactTel", displayName: "电话"},
        {name: "salesVolume", displayName: "纸品容量(元/月)"},
        {name: "promoter", displayName: "促销员"},
      ],
      sheetName: "门店",
    };
    const productSheet = getProductSheet();
    const ecSheet = {
      dataLoading: async (params: any) => {
        return await EC.queryForSheet({
          ecLevel: Enum.ECLevel.EC3,
          pageTypeId: Enum.PageType.ACTIVITY_APPLICATION,
          budgetProjectId: props.data?.formSa?.budgetProjectId
        });
      },
      data: null,
      names: [
        {name: "ecName1", displayName: "费用大类名称"},
        {name: "ecName2", displayName: "费用小类名称"},
        {name: "ecName3", displayName: "费用项名称"},
        {name: 'remark', displayName: '费用项描述'},
        {name: "extendFieldsSa", displayName: "申请所需内容"},
        {name: "revenueTypeNames", displayName: "核算类型"},

      ],
      sheetName: "费用类别",
    };
    const revenueTypeSheet = {
      dataLoading: async (params: any) => {
        return await RevenueType.queryForSheet({
          revenueTypeIds: "1,101,151,152,301,302,303,304,311,312",
        });
      },
      data: null,
      names: [
        {name: "revenueTypeName", displayName: "核算类型"},
        {name: "extendFieldsSa", displayName: "申请所需内容"},

      ],
      sheetName: "核算类型",
    };
    const companySheet = {
      dataLoading: async (params: any) => {
        return await Company.search({isActive: true});
      },
      data: null,
      names: [
        {name: 'companyCode', displayName: '公司编号'},
        {name: 'companyName', displayName: '公司名称'},
      ],
      sheetName: '公司',
    };

    const importExcels = [
      {
        name: "全部下载",
        sheetProps: [soldToSheet, shopSheet, productSheet, ecSheet, revenueTypeSheet, companySheet]
      }, {
        name: "客户列表",
        sheetProps: [soldToSheet]
      }, {
        name: "门店列表",
        sheetProps: [shopSheet]
      }, {
        name: "产品列表",
        sheetProps: [productSheet]
      }, {
        name: "费用类别列表",
        sheetProps: [ecSheet]
      }, {
        name: "核算类型列表",
        sheetProps: [revenueTypeSheet]
      }, {
        name: "公司列表",
        sheetProps: [companySheet]
      }
    ];
    setImportExcels(importExcels);
  }, [props.data]);

  const pageGridSettings = Object.assign({
    antdProps: {
      dataSource,
      initRowFieldConfigs: (record: any) => {
        return initRowFieldConfigs(record, data?.ecFieldConfigs);
      },
      pagination: {
        defaultPageSize: 10,
        showSizeChanger: true
      }
    }
  }, gridSettings);

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
      extra={
        <>
          <Dropdown.Button
            buttonsRender={(buttons: ReactNode[]) => {
              return [buttons[0], <Button type={"primary"} style={{width: 50, fontSize: 12}}>更多</Button>]
            }}
            type='primary'
            onClick={() => {
              const row: any = {};
              if (dataSource && dataSource.length > 0) {
                const lastRow = last(dataSource);
                row.ecId = lastRow.ecId;
                row.revenueType = lastRow.revenueType;
                row.soldToCode = lastRow.soldToCode;
                row.soldToName = lastRow.soldToName;
                row.boId = lastRow.boId;
                row.boName = lastRow.boName;
              }
              setModalProps({
                visible: true,
                title: '选择费用类型',
                type: ModalTypeEnums.PREV,
                id: null,
                data: {
                  row: row,
                  rows: dataSource,
                  rowIndex: -1,
                  formSa: data?.formSa,
                }
              });
            }}
            overlay={
              <Menu items={
                [{
                  key: 'import',
                  label: '导入',
                  onClick: () => {
                    setModalProps({title: '费用明细导入', visible: true, type: ModalTypeEnums.IMPORT});
                  }
                }, {
                  key: 'export',
                  label: '导出',
                  onClick: async () => {
                    await download(FormSa.Buttons.Path.downloadTempForExport, formatter({
                      method: 'POST',
                      body: {
                        pageTypeId: data?.formSa?.pageTypeId,
                        budgetProjectId: data?.formSa?.budgetProjectId,
                        tempName: 'ActivityGeneralApply.xlsx',
                        formSaDetails: JSON.stringify(dataSource),
                      }
                    }));
                  }
                }]
              }/>
            }
            style={{float: 'right'}}>
            新建
          </Dropdown.Button>
        </>
      }
    >
      {isLoaded && modalProps.visible && modalProps.type === ModalTypeEnums.IMPORT && (
        <ImportModalApp
          title={modalProps.title}
          visible={modalProps.visible}
          settingsUrl="/expenseapi/saButtons/getImportSettings"
          uploadingUrl="/expenseapi/saButtons/importUploading"
          onClose={onModalClose}
          onSave={onImportSave}
          clientParameters={{
            formSa: data?.formSa,
            formSaDetails: JSON.stringify(dataSource),
            form: JSON.stringify(data?.form),
          }}
          importExcels={importExcels}
          events={{
            downloadTempByEc: () => {
              setExportModalProps({visible: true, data: data, title: '下载数据模板'});
            },
          }}
        />
      )}
      {isLoaded && exportModalProps.visible && (
        <ExportTemplateModalApp
          {...exportModalProps}
          onClose={() => {
            setExportModalProps({visible: false});
          }}
        />
      )}
      {isLoaded && modalProps.visible && modalProps.type === ModalTypeEnums.PREV && (
        <FormSaDetailPrevApp {...modalProps} onClose={onModalClose} onSave={onPrevSave}/>
      )}
      {isLoaded && showFixedModal(modalProps) && (
        <DetailFixedApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && showSellinQtyModal(modalProps) && (
        <DetailSellinQuantityApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && showSellinRevModal(modalProps) && (
        <DetailSellinRevenueApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && showPosQtySupplyPriceModal(modalProps) && (
        <DetailPosQtySupplyPriceApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && showPosQtySellinPriceModal(modalProps) && (
        <DetailPosQtySellinPriceApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && showPosRevModal(modalProps) && (
        <DetailPosRevenueApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      )}
      {isLoaded && (
        <DetailGrid {...pageGridSettings} params={data} autoColumn={['rowNumber']}/>
      )}
    </WdiPanel>
  );
};

/**
 * 默认列：同申请；可配置列：同申请
 * 可配置字段按费用项+核算类型的申请所需内容来显示，加上原申请金额；）其中产品政策要变为超链接形式，点击后打开产品政策的查看页面（去掉more和动态信息）
 */
const initRowFieldConfigsApproval = (record: any, ecFieldConfigs: API.EcFieldConfig[] | undefined) => {
  return initRowFieldConfigs(record, ecFieldConfigs);
};

export const FormSaDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});

  useEffect(() => {
    GridApi.searchConfig({id: 'FormSADetailForGeneralApproval', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.ecId.width = 200;
      settings.formSchema.allFields.soldToCode.width = 180;
      settings.formSchema.allFields.revenueType.width = 120;
      settings.formSchema.allFields.paymentMethodId.width = 120;

      settings.formSchema.allFields.amount.width = 120;
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);
      settings.formSchema.allFields.revenueSellinForecast.aggr = TableColumnRanderFormats.sumAggr('revenueSellinForecast', 2);
      settings.formSchema.allFields.revenuePosForecast.aggr = TableColumnRanderFormats.sumAggr('revenuePosForecast', 2);
      settings.formSchema.allFields.revenueSellinActual.aggr = TableColumnRanderFormats.sumAggr('revenueSellinActual', 2);
      settings.formSchema.allFields.revenuePosActual.aggr = TableColumnRanderFormats.sumAggr('revenuePosActual', 2);

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const {dataSource, data} = props;

  const pageGridSettings = Object.assign({
    antdProps: {
      dataSource,
      initRowFieldConfigs: (record: any) => {
        return initRowFieldConfigsApproval(record, data?.ecFieldConfigs);
      },
      pagination: {
        defaultPageSize: 10,
        showSizeChanger: true
      }
    }
  }, gridSettings);

  useEffect(() => {
    if (data?.form) {
      setModalProps(Object.assign({}, modalProps, {title: "费用明细变更对比", data: {form: data.form}}));
    }
  }, [data]);

  const exportDetails = () => {
    const columns = [
      {name: 'boName', displayName: '四级使用部门'},
      {name: 'soldToCode', displayName: '客户编号'},
      {name: 'soldToName', displayName: '客户名称'},
      {name: 'shopCode', displayName: '门店编号'},
      {name: 'shopName', displayName: '门店名称'},
      {name: 'productBuyNames', displayName: '产品别'},
      {name: 'ecName', displayName: '费用项'},
      {name: 'revenueTypeName', displayName: '核算类型'},
      {name: 'paymentMethodName', displayName: '支付方式'},
      {name: 'amount', displayName: '申请金额'},
      {name: 'companyCode', displayName: '付款公司编号'},
      {name: 'companyName', displayName: '付款公司名称'},
      {name: 'boName1', displayName: '一级使用部门'},
      {name: 'boName2', displayName: '二级使用部门'},
      {name: 'boName3', displayName: '三级使用部门'},
      {name: 'ecName1', displayName: '费用大类'},
      {name: 'ecName2', displayName: '费用小类'},
      {name: 'toSfa', displayName: '是否同步到SFA', type: Enum.FieldType.BOOLEAN},
      {name: 'roiForecast', displayName: '预计费比', type: Enum.FieldType.NUMBER},
      {name: 'remark', displayName: '备注'},
      {name: 'productFgNames', displayName: '指定货补产品别'},
      {name: 'activityStartDate', displayName: '活动开始日期', type: Enum.FieldType.DATE_TIME},
      {name: 'activityEndDate', displayName: '活动截止日期', type: Enum.FieldType.DATE_TIME},
      {name: 'supplyStartDate', displayName: '开始供货日期', type: Enum.FieldType.DATE_TIME},
      {name: 'supplyEndDate', displayName: '截止供货日期', type: Enum.FieldType.DATE_TIME},
      {name: 'priceSellinBefore', displayName: '原供货价(箱/大袋)', type: Enum.FieldType.NUMBER},
      {name: 'priceSellinAfter', displayName: '促销供货价(箱/大袋)', type: Enum.FieldType.NUMBER},
      {
        name: 'priceSellinBeforeMin',
        displayName: '原供货价(中包)',
        type: Enum.FieldType.NUMBER,
      },
      {
        name: 'priceSellinAfterMin',
        displayName: '促销供货价(中包)',
        type: Enum.FieldType.NUMBER,
      },
      {name: 'pricePosBefore', displayName: '原零售价(中包)', type: Enum.FieldType.NUMBER},
      {name: 'pricePosAfter', displayName: '促销零售价(中包)', type: Enum.FieldType.NUMBER},
      {name: 'unitExpenseSoldTo', displayName: '单位补差金额(客户承担)', type: Enum.FieldType.NUMBER},
      {name: 'unitExpense', displayName: '单位补差金额(箱/大袋)', type: Enum.FieldType.NUMBER},
      {
        name: 'quantitySellinForecast',
        displayName: '预计出货销量(箱/大袋)',
        type: Enum.FieldType.NUMBER,
      },
      {name: 'quantityTarget', displayName: '达标销量(箱/大袋)', type: Enum.FieldType.NUMBER},
      {name: 'revenueSellinForecast', displayName: '预计出货销售额', type: Enum.FieldType.NUMBER},
      {name: 'revenueTarget', displayName: '达标销售额', type: Enum.FieldType.NUMBER},
      {
        name: 'quantityPosForecast',
        displayName: '预计POS销量(箱/大袋)',
        type: Enum.FieldType.NUMBER,
      },
      {name: 'revenuePosForecast', displayName: '预计POS销售额', type: Enum.FieldType.NUMBER},
      {name: 'executionRateForecast', displayName: '转化率', type: Enum.FieldType.NUMBER},
      {name: 'activitySubjectName', displayName: '活动主题'},
      {name: 'displayTypeNames', displayName: '陈列形式'},
      {name: 'displayQuantity', displayName: '陈列数量'},
      {name: 'displayArea', displayName: '陈列面积'},
      {name: 'targetShopQuantity', displayName: '目标门店数/场次'},
      {name: 'tpmDetailId', displayName: '活动明细编号'},
      {name: 'productBuyCodes', displayName: '产品别编号'},
      {
        name: 'quantitySellinActual',
        displayName: '实际出货销量(箱/大袋)',
        type: Enum.FieldType.NUMBER,
      },
      {name: 'revenueSellinActual', displayName: '实际出货销售额', type: Enum.FieldType.NUMBER},
      {
        name: 'quantityPosActual',
        displayName: '实际POS销量(箱/大袋)',
        type: Enum.FieldType.NUMBER,
      },
      {name: 'revenuePosActual', displayName: '实际POS销售额', type: Enum.FieldType.NUMBER},
      {name: 'roiActual', displayName: '实际费比', type: Enum.FieldType.NUMBER},
      {name: 'sfaResultDesc', displayName: 'SFA执行结果描述'},
      {name: 'sfaShopQuantity', displayName: 'SFA执行门店数量'},
      {name: 'priceLimit', displayName: '限价', type: Enum.FieldType.NUMBER},
      {name: 'priceLimitBelowRate', displayName: '低于限价比例', type: Enum.FieldType.NUMBER},
      {name: 'grossRate', displayName: '毛利率(不含折旧)', type: Enum.FieldType.NUMBER},
      {name: 'ip', displayName: 'IP'},
      {name: 'formSaDetailIdOriginal', displayName: '原活动明细ID', type: Enum.FieldType.TEXT},
      {name: 'sfaAmount', displayName: 'SFA执行金额', type: Enum.FieldType.NUMBER},
    ];
    FormSaDetail.getsEx(Number(data?.form?.formId)).then((response) => {
      const formSASheet = {
        data: response?.data,
        names: columns,
        sheetName: '活动明细',
        cells: {
          activityStartDate: (_: any, row: any, value: any) => {
            if (value) {
              return wdiCore.Date.DateToString(row.activityStartDate);
            } else {
              return wdiCore.Date.DateToString(props?.data?.formSa?.activityStartDate);
            }
          },
          activityEndDate: (_: any, row: any, value: any) => {
            if (value) {
              return wdiCore.Date.DateToString(row.activityEndDate);
            } else {
              return wdiCore.Date.DateToString(props?.data?.formSa?.activityEndDate);
            }
          },
          supplyStartDate: (_: any, row: any, value: any) => {
            if (value) {
              return wdiCore.Date.DateToString(row.supplyStartDate);
            } else {
              return wdiCore.Date.DateToString(props?.data?.formSa?.supplyStartDate);
            }
          },
          supplyEndDate: (_: any, row: any, value: any) => {
            if (value) {
              return wdiCore.Date.DateToString(row.supplyEndDate);
            } else {
              return wdiCore.Date.DateToString(props?.data?.formSa?.supplyEndDate);
            }
          },
        },
      };
      toExcel({
        name: data?.form?.formNo + '_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
        sheetProps: [formSASheet],
      });
    });
  };

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>} collapsed={true}
      extra={
        <Space>
          <Button type='primary' onClick={(e) => {
            e.stopPropagation();
            exportDetails();
          }}>
            导出
          </Button>
          <Button
            hidden={wdiCore.Object.IsNullOrUndefined(data?.form?.relatedFormId)}
            onClick={(e) => {
              e.stopPropagation();
              setModalProps({...modalProps, ...{visible: true}});
            }}
            type='primary'>
            变更对比
          </Button>
        </Space>
      }>
      {isLoaded && modalProps.visible && data?.form?.relatedFormId && (
        <FormSaDetailCompareModalApp
          {...modalProps}
          onClose={() => {
            setModalProps({...modalProps, ...{visible: false}});
          }}
        />
      )}
      {isLoaded && (
        <DetailGrid {...pageGridSettings} />
      )}
    </WdiPanel>
  );
};
